import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function ExposureNeg2Icon(props: IconProps) {
    return <Icon {...props} iconKey={"exposure_neg_2"}/>
}
